module.exports = __webpack_public_path__ + "static/img/logo-diamond.7a6092b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo-diamond.png
// module id = KKqQ
// module chunks = 0